// extracted by mini-css-extract-plugin
export default {"bottom_tab_bar":"bottom_tab_bar__8e740e31","tab_container":"tab_container__8e740e31","tab":"tab__8e740e31","selected":"selected__8e740e31","icon":"icon__8e740e31"};